import { NOTIFICATIONS_TYPE } from '@core/constants/NOTIFICATIONS';

/**
 * Show a notification message in the screen with a message.
 * @type {function}
 * @param {string} message - The message to show in the notification.
 * @param {string} [type=NOTIFICATIONS_TYPE.SUCCESS] - The type of the notification.
 * @returns {void}
 */
export const showNotification = (message, type = NOTIFICATIONS_TYPE.SUCCESS) => {
    /** @type {HTMLDivElement} */
    const notification = document.createElement('div');
    notification.classList.add('notification-message');
    notification.classList.add(type);
    notification.classList.add('label-medium');
    notification.textContent = message;

    /** @type {HTMLSpanElement} */
    const closeButton = document.createElement('md-icon');
    closeButton.classList.add('close-notification-btn');
    closeButton.innerHTML = 'close';
    closeButton.addEventListener('click', () => {
        notification.classList.remove('show');
        setTimeout(() => {
            notification.parentNode.remove();
        }, 300);
    });
    notification.appendChild(closeButton);

    /* Clear timeout when mouse is over the notification */
    notification.addEventListener('mouseenter', () => {
        clearTimeout(notification.timeout);
    });
    /* Set timeout when mouse leaves the notification */
    notification.addEventListener('mouseleave', () => {
        notification.timeout = setTimeout(() => {
            notification.classList.remove('show');
            setTimeout(() => {
                notification.parentNode.remove();
            }, 300);
        }, 1000);
    });

    /** @type {NodeListOf<HTMLElement>} */
    const existingNotifications = document.querySelectorAll('.notification-message');
    if (existingNotifications.length > 0) {
        /** @type {HTMLLIElement} */
        const listItem = document.createElement('li');
        listItem.appendChild(notification);

        /** @type {HTMLUListElement} */
        const notificationList = document.querySelector('.notification-list');
        notificationList.appendChild(listItem);
    } else {
        /** @type {HTMLUListElement} */
        const notificationList = document.createElement('ul');
        notificationList.classList.add('notification-list');

        /** @type {HTMLLIElement} */
        const listItem = document.createElement('li');
        listItem.appendChild(notification);

        notificationList.appendChild(listItem);
        notificationList.classList.add('show');
        document.body.appendChild(notificationList);
    }

    notification.classList.add('show');

    /* Default timeout when the notification is shown is 5 seconds */
    notification.timeout = setTimeout(() => {
        notification.classList.remove('show');
        setTimeout(() => {
            notification.parentNode.remove();

            /* check if all the notifications are removed and remove the list */
            if (document.querySelectorAll('.notification-message').length === 0) {
                /** @type {HTMLUListElement} */
                const notificationList = document.querySelector('.notification-list');
                notificationList.classList.remove('show');
                notificationList.remove();
            }
        }, 300);
    }, 5000);
};
